const AudioContext = window.AudioContext || window.webkitAudioContext || window.mozAudioContext || window.msAudioContext;  // eslint-disable-line
const audioCtx = AudioContext ? new AudioContext() : '';
let gainNode; // 创建音量节点

const soundBuffer = {
  getBuffer(link) {
    return new Promise((resolve, reject) => {
      if (audioCtx) {
        const request = new XMLHttpRequest(); // eslint-disable-line
        request.open('GET', link, true);
        request.responseType = 'arraybuffer';
        request.onload = () => {
          audioCtx.decodeAudioData(request.response, buffer => {
            resolve(buffer)
          }, e => {
            console.log('reject');
            reject(e);
          });
        };
        request.send();
      } else {
        reject('not support AudioContext'); // eslint-disable-line
      }
    })
  },
  createSound(buffer) {
    if (audioCtx.state === 'suspended') {
      console.log('重启audioCtx');
      audioCtx.resume();
    }
    // 创建音频源
    const source = audioCtx.createBufferSource();
    // 把 buffer 格式的音频数据赋值给 AudioBufferSourceNode 对象的 buffer 属性
    source.buffer = buffer;
    // 创建音量节点
    gainNode = audioCtx.createGain();
    // 连接节点对象
    source.connect(gainNode);
    gainNode.connect(audioCtx.destination);
    return source;
  },
  // 获取 audioCtx 的硬件物理时间
  getCurrentTime() {
    return audioCtx.currentTime;
  },
  // 控制音量大小 [0, 1]
  setVolume(value) {
    if (gainNode.gain) gainNode.gain.value = value;
  },
}
export default soundBuffer;



// WEBPACK FOOTER //
// ./src/components/listen/audioCtx/soundBuffer.js